import { render, staticRenderFns } from "./Portfolio_historic.vue?vue&type=template&id=1bfd1e30&scoped=true&"
import script from "./Portfolio_historic.vue?vue&type=script&lang=js&"
export * from "./Portfolio_historic.vue?vue&type=script&lang=js&"
import style0 from "./Portfolio_historic.vue?vue&type=style&index=0&id=1bfd1e30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfd1e30",
  null
  
)

export default component.exports